import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "frontend-layout" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-flex pt-6" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi-pencil me-1" }, null, -1)
const _hoisted_6 = { class: "frontend-layout-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopSearch = _resolveComponent("TopSearch")!
  const _component_MrUiKitBreadcrumb = _resolveComponent("MrUiKitBreadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.layoutConfig.showTopSearch)
      ? (_openBlock(), _createBlock(_component_TopSearch, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.layoutConfig.hideBreadcrumb)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_MrUiKitBreadcrumb, {
                items: _ctx.items,
                onNavigate: _ctx.onNavigateBreadcrumb
              }, null, 8, ["items", "onNavigate"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.canUpdateEntity)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToBackoffice && _ctx.goToBackoffice(...args))),
              class: "ms-auto link-primary pointer-sub mb-2 align-items-md-center"
            }, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.t('common.operations.edit')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}